import { React, useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedCountry,
  setSelectCountryLangCode,
  setCurrentLanguage,
  setPreferredLanguage,
  setLanguageFullName,
  setRegion
} from "../../settingsSlice";

const WebsiteCountry = () => {

  const [selectYourCountry, setSelectYourCountry] = useState( "Select Your Country");
  const { selectedCountry } = useSelector((state) => state.settings);

  const dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState("US");

  const setRequiredLanguage = (countryCode) => {
    
    if (
      countryCode == "aa" ||
      countryCode == "NA" ||
      countryCode == null ||
      countryCode == "" ||
      countryCode == undefined
    ) {
      return false;
    }

    const locale = new Intl.Locale("und", { region: countryCode });
    const maximizedLocale = locale.maximize(); // the magic
    const selectedLanguage = maximizedLocale.language;
    const languageFullName = getLanguageFullName(selectedLanguage);

    dispatch(setSelectedCountry(maximizedLocale));
    dispatch(setLanguageFullName(languageFullName));
    dispatch(setSelectCountryLangCode(selectedLanguage));

    setSelectedLanguage(countryCode);    
  };

  const getLanguageFullName = (langCode) => {
    return new Intl.DisplayNames(["en"], { type: "language" }).of(langCode);
  };

  return (
    <>
      <div className="col-12 col-md-6">
        <label className="form-label section-title">{selectYourCountry}</label>
        <ReactFlagsSelect
          searchable="true"
          selected={selectedLanguage}
          onSelect={(code) => setRequiredLanguage(code)}
          defaultCountry="IN"
          selectButtonClassName="menu-flags-button"
          showSelectedLabel={true}
          id="country"
          required
        />
      </div>
    </>
  );
};

export default WebsiteCountry;
